/**
 * DataTableLoading Component
 *
 * Tablo veri yüklenirken veya yeniden fetch edilirken gösterilen loading overlay'i.
 * Tablonun üzerine yarı saydam beyaz bir katman olarak render edilir.
 *
 * Özellikler:
 * - Position absolute ile tablonun üzerine yerleşir
 * - Yarı saydam beyaz arka plan (opacity-50)
 * - Merkezde spinner gösterir
 *
 * Kullanım:
 * Bu component DataTableInner tarafından otomatik olarak gösterilir.
 * tableStatus 'loading' veya 'fetching' olduğunda render edilir.
 *
 * @returns JSX.Element - Loading overlay UI'ı
 */
export default function DataTableLoading() {
  return (
    <div className="d-flex align-items-center justify-content-center w-100 h-100 position-absolute bottom-0 start-0 end-0 bg-white opacity-50">
      <div className="me-2 spinner-border w-15px h-15px text-muted"></div>
    </div>
  );
}
